import { ApiViewProjectDto } from 'kes-common';
import React, { Dispatch, SetStateAction } from 'react';

export default React.createContext<{
	project: ApiViewProjectDto;
	refetchProject: (options?: any) => any;
	setProject: Dispatch<SetStateAction<ApiViewProjectDto>>;
}>({ project: {} as ApiViewProjectDto, refetchProject: () => {}, setProject: () => {} });
